import { PageHeader } from "@/components/PageHeader";
import { Section, Eyebrow } from "@/components/kit";
import { Reveal } from "@/components/motion";
import { ContactForm } from "@/components/ContactForm";
import { DuoBanner } from "@/components/DuoBanner";
import { Check, Crown } from "lucide-react";
import { VIP_PERKS, IMG } from "@/data/content";

export default function VIP() {
  return (
    <>
      <PageHeader
        eyebrow="Membresía · Área VIP"
        eyebrowColor="#E8C547"
        title={["Un pase", "detrás de cámaras."]}
        subtitle="El Área VIP es para quienes quieren vivir la serie desde adentro: sin cortes, con extras exclusivos y una comunidad más cercana. Acceso a contenido que no se transmite, eventos con Anto y Bella, y regalos que solo llegan a quienes están adentro. Contenido extendido, acceso directo al dúo y un kit de viajero que llega a tu casa."
      />

      <Section className="!pt-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_1fr]">
          <Reveal>
            <div className="relative overflow-hidden rounded-[2.5rem] bg-ink p-9 text-cream">
              <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-gold/20 blur-3xl" />
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold">
                  <Crown className="h-5 w-5 text-ink" />
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-gold">
                  Miembro VIP
                </span>
              </div>
              <div className="mt-8 flex items-end gap-2">
                <span className="font-display text-6xl font-extrabold tracking-tighter">
                  $99
                </span>
                <span className="mb-2 font-mono text-sm uppercase tracking-widest text-cream/50">
                  MXN / mes
                </span>
              </div>
              <p className="mt-2 text-cream/60">Cancela cuando quieras.</p>
              <ul className="mt-8 space-y-3">
                {VIP_PERKS.map((p) => (
                  <li key={p} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-mint">
                      <Check className="h-3 w-3 text-ink" strokeWidth={3} />
                    </span>
                    <span className="text-cream/85">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-[2.5rem] bg-white p-8 shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
              <Eyebrow color="#E8C547">Solicitar acceso VIP</Eyebrow>
              <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-ink">
                ¿Listo para entrar?
              </h2>
              <p className="mt-2 mb-6 text-sm text-ink/60">
                Reserva tu lugar. Te enviaremos las instrucciones de acceso. La membresía VIP es limitada cada temporada para mantener la cercanía con el dúo. Si se llena, te avisamos cuando abra de nuevo.
              </p>
              <ContactForm
                testidPrefix="vip"
                sourcePath="/vip"
                combo="Reservar acceso VIP"
                accent="#E8C547"
                submitLabel="Reservar mi acceso VIP"
                successMsg="¡Estás dentro del Área VIP!"
                fields={[
                  { name: "nombre", label: "Nombre completo", placeholder: "Tu nombre" },
                  { name: "email", label: "Email", type: "email", placeholder: "tucorreo@email.com" },
                  { name: "telefono", label: "Teléfono", type: "tel", placeholder: "+52 ...", required: false },
                ]}
              />
            </div>
          </Reveal>
        </div>
      </Section>

      <DuoBanner
        image={IMG.duoVipFans}
        imgSide="right"
        alt
        tint="#E8C547"
        eyebrowColor="#E8C547"
        title="Acceso VIP: donde pasa lo que nadie más ve."
        text="Bloopers, detrás de cámaras y las risas que no cupieron en la tele. Anto y Bella te guardan un lugar en primera fila."
        cta={{ to: "/en-vivo", label: "Ir a En Vivo", variant: "coral" }}
      />
    </>
  );
}
